import React from "react";
import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/api";

export function CategoryTile({ category, active, to }) {
  return (
    <Link
      to={to}
      data-testid={`category-tile-${category.slug}`}
      className={`snap-start flex flex-col items-center gap-2 min-w-[80px] shrink-0 group ${active ? "" : ""}`}
    >
      <div
        className={`w-16 h-16 rounded-full overflow-hidden border-2 transition-all ${
          active ? "border-hyd-gold shadow-glow-gold" : "border-hyd-border group-hover:border-hyd-gold/60"
        }`}
      >
        {category.image_url ? (
          <img src={imageUrl(category.image_url)} alt={category.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-hyd-panel2 grid place-items-center text-hyd-text3 text-xs">
            {category.name.slice(0, 2)}
          </div>
        )}
      </div>
      <div className={`text-[13px] text-center font-semibold leading-tight max-w-[96px] ${active ? "text-hyd-gold" : "text-hyd-text"}`}>
        {category.name}
      </div>
    </Link>
  );
}
